import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import {
  IsomorphicPersistent,
  Persistent,
  IsomorphicQuery,
  Query,
  Isomorphic,
  Serializable,
  AppController,
  SubController,
  Everything,
} from '@hit/amorphic-types';
import { HavenStatsDClient } from '@hit/haven-statsd-client';
import nconf from 'nconf';
import { Utils } from '../Utils';
nconf.argv().env();

@supertypeClass({ toClient: false, toServer: true })
export class HavenStats extends Everything {
  @property()
  private static _singleton: HavenStats = null;

  @property()
  private havenStatsDClient: HavenStatsDClient;

  public static singletonStatsDClient() {
    const singleton = HavenStats._singleton || (HavenStats._singleton = HavenStats.new());
    return singleton.havenStatsDClient;
  }

  constructor() {
    super();
  }

  static new() {
    return new HavenStats().init();
  }

  init() {
    const appName = nconf.get('APPLICATION');
    const channel = nconf.get('CHANNEL');
    const telegrafHost = nconf.get('TELEGRAF_HOST');
    this.havenStatsDClient = new HavenStatsDClient({ channel: channel, appName: appName, telegrafHost: telegrafHost });
    return this;
  }

  /**
   * Calculates the run time of a callback
   * @param callback
   */
  public static async timeTaken<T>(callback: () => Promise<T>): Promise<[T, number]> {
    const requestTime = process.hrtime();
    const response = await callback();
    return [response, Utils.getTimeOffset(requestTime)];
  }

  /**
   * Creates histogram metrics for a callback
   * @param callback
   * @param metricName
   * @param tags optional descriptors for aggregating metrics
   */
  public static async histogram<T = never>(callback: () => Promise<T>, metricName: string, tags?: object): Promise<T> {
    const [response, responseTime] = await this.timeTaken(callback);
    HavenStats.singletonStatsDClient().histogram(metricName, responseTime, tags);
    return response;
  }
}
